import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import { StyledText } from "./basic";
import { SearchIcon, CloseIcon, ChevronRightArrow, NewBackButton, } from "../svgs";

const FullScreenSelect = ({
  data,
  setValue,
  selected,
  placeholder,
  activeColor,
  zIndex,
  hasError
}) => {
  const [openSelectView, setOpenSelectView] = useState(false);
  const borderColor = '#000';
  return (
    <>
      {
        openSelectView &&
        <FullScreenSelectView
          title={placeholder}
          data={data}
          setValue={setValue}
          zIndex={zIndex}
          closeView={() => setOpenSelectView(false)}
        />
      }
      <div style={{ marginBottom: '20px' }}>
        <div
          onClick={() => setOpenSelectView(true)}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 20px',
            borderRadius: '20px',
            border: `1px solid ${hasError ? 'red' : (selected ? activeColor : borderColor)}`
          }}
        >
          <StyledText size={14} style={{ fontFamily: 'MTNRegular', margin: 0 }}>{selected || `Select ${placeholder}`}</StyledText>
          <ChevronRightArrow width={12} />
        </div>
      </div>
    </>
  )
}

export const FullScreenSelectView = ({
  data,
  closeView,
  title,
  setValue,
  isSearchable = false,
  zIndex,
  closeOnSelect = true,
}) => {
  const [currentData, setData] = useState([]);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (data) {
      setData(data)
    }
  }, [data]);

  useEffect(() => {
    if (Array.isArray(data)) {
      if (searchText?.trim() === '') {
        setData(data);
      } else {
        const found = data.filter(({ label }) => label?.toLowerCase().includes(searchText?.toLowerCase()))
        setData(found);
      }
    }
  }, [searchText])
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: zIndex || 2,
        width: '100%',
        height: '100vh',
        boxSizing: 'border-box',
        left: 0,
        top: 0,
        background: '#F2F2F2',
        padding: '10px 20px',
        overflowY: 'scroll',
      }}>
      <BackButtonContainer onClick={closeView}>
        <NewBackButton />
      </BackButtonContainer>

      <StyledText size={24} style={{ fontFamily: 'MTNMedium', margin: '10px 0', textAlign: 'center' }}>Select {title}</StyledText>
      <div style={{
        textAlign: 'center',
        display: 'flex',
        width: '100%',
        background: '#fff',
        maxWidth: '300px',
        border: '1px solid #C8CBCB',
        borderRadius: '8px',
        margin: '15px auto 15px auto',
        overflow: 'hidden'
      }}>
        <input
          type="text"
          style={{ fontFamily: 'MTNMedium', fontSize: '14px', padding: '8px 12px', border: 'none', flexGrow: 1 }}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          placeholder={`Search for ${title?.toLowerCase()}`} />

        <div
          onClick={() => setSearchText('')}
          style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', boxSizing: 'border-box' }}
        >
          {searchText === '' ? <SearchIcon fill={'#C8CBCB'} /> : <CloseIcon fill={'#C8CBCB'} />}
        </div>
      </div>
      {
        currentData.length > 0 ? currentData.map(({ label, value }) => {
          return (
            <div
              onClick={() => {
                setValue(value);
                if (closeOnSelect) closeView();
              }}
              style={{
                cursor: 'pointer',
                boxShadow: '0 5px 5px rgba(0,0,0,0.1)',
                marginBottom: '5px',
                borderRadius: '12px',
                boxSizing: 'border-box',
                padding: '12px',
                overflow: 'hidden',
                background: '#fff',
              }}>
              <StyledText size={16} style={{ fontFamily: 'MTNMedium', margin: '0 0 3px 0' }}>{label}</StyledText>
            </div>
          )
        }) : <StyledText style={{ textAlign: 'center', color: '#EE2737' }}>{title} not found</StyledText>
      }
    </div >
  )
}

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: 8px;
  top: 10px;
  left: 10px;
`;

export default FullScreenSelect;